import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxButtonModule, DxDataGridModule, DxHtmlEditorModule } from "devextreme-angular";
import { CreateUpdateActivityDinamicComponent } from './create-update-activity-dinamic.component';
import { EditServiceWorkOrderModule } from 'src/app/shared/edit-service-work-order/edit-service-work-order.module';
import { DxTagBoxModule, DxNumberBoxModule, DxResponsiveBoxModule, DxAutocompleteModule, DxSliderModule, DxTemplateModule, DxSchedulerModule, DxTextAreaModule,DxContextMenuModule, DxTreeViewModule, DxDropDownBoxModule, DxSpeedDialActionModule, DxScrollViewModule, DxTextBoxModule, DxPopupModule, DxSelectBoxModule, DxDateBoxModule, DxTabPanelModule, DxAccordionModule, DxButtonGroupModule, DxCheckBoxModule, DxRangeSliderModule, DxDropDownButtonModule, DxRadioGroupModule, DxFileUploaderModule, DxToolbarModule, DxSortableModule } from "devextreme-angular";
// import { EditSalesLeadDinamicoModule } from 'src/app/pages/sales-management/sales-leads/edit-sales-lead-dinamico/edit-sales-lead-dinamico.module';

@NgModule({
  declarations: [
    CreateUpdateActivityDinamicComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    DxSelectBoxModule, 
    DxButtonModule,
    DxDataGridModule,
    DxTagBoxModule, 
    DxScrollViewModule, 
    DxTextBoxModule, 
    DxPopupModule, 
    DxDateBoxModule, 
    DxAccordionModule, 
    DxButtonGroupModule,
    DxDropDownButtonModule,
    DxSchedulerModule,
    DxPopupModule,
    EditServiceWorkOrderModule,
    FormsModule,
    ReactiveFormsModule,
    DxTreeViewModule,
    DxDropDownBoxModule,
    DxAccordionModule,
    DxTabPanelModule,
    DxSpeedDialActionModule,
    DxButtonModule,
    DxTextAreaModule,
    DxContextMenuModule,
    DxSchedulerModule,
    DxDateBoxModule,
    DxTextBoxModule,
    DxRadioGroupModule,
    DxCheckBoxModule,
    DxPopupModule,
    DxScrollViewModule,
    DxNumberBoxModule,
    DxAutocompleteModule,
    DxSelectBoxModule,
    DxSliderModule,
    DxRangeSliderModule,
    DxDataGridModule,
    DxTagBoxModule,
    DxFileUploaderModule,
    DxTemplateModule,
    DxResponsiveBoxModule,
    DxHtmlEditorModule,
    // EditSalesLeadDinamicoModule
  ],
  exports: [CreateUpdateActivityDinamicComponent]
})
export class CreateUpdateActivityDinamicModule { }
 